import { createActionGroup, createFeature, createFeatureSelector, createReducer, emptyProps, on, props } from "@ngrx/store";
import { getDefaultUserSettings, User } from "../../../globals/store/user.data";

export interface UserState {
  loggedIn: boolean,
  loading: boolean,
  fromOAuth: boolean,
  user: User,
  showAccountPlansDialog: string,
}

export const getBlankUser = (): User => ({
  firstName: null,
  lastName: null,
  email: null,
  emailVerified: false,
  uid: null,
  accounts: [],
  settings: getDefaultUserSettings(),
});

export const initialStateCreator = (): UserState => ({
  loggedIn: false,
  loading: false,
  fromOAuth: false,
  user: getBlankUser(),
  showAccountPlansDialog: null,
});

export const userActions = createActionGroup({
  source: 'User',
  events: {
    'Loaded': (user: User) => ({ user }),
    'Loading': emptyProps(),
    'Show View Plans': (accountId: string) => ({ accountId }),
    'Success': emptyProps(),
    'Set From OAuth': emptyProps(),
    'Update User': (id: string, changes: Partial<User>) => ({ id, changes }),
    'Modify User': (user: User) => ({ user }),
    'Logout': emptyProps(),
    'Verify Email': emptyProps(),
  }
})

export const userReducer = createReducer(
  initialStateCreator(),
  on(userActions.loading, (state) => ({ ...state, loading: true, })),
  on(userActions.loaded, (state, { user }) => ({ ...state, loading: false, loggedIn: !!user?.uid, user })),
  on(userActions.setFromOAuth, (state) => ({ ...state, fromOAuth: true })),
  on(userActions.showViewPlans, (state, { accountId }) => ({ ...state, showAccountPlansDialog: accountId })),
  on(userActions.success, (state) => ({ ...state, showAccountPlansDialog: null })),
  on(userActions.updateUser, (state, { id, changes }) => {
    if (state.user?.uid !== id) return state
    return { ...state, user: { ...state.user, ...changes } }
  }),
  on(userActions.modifyUser, (state, { user }) => ({ ...state, user })),
  on(userActions.logout, (state) => ({ ...initialStateCreator() })),
  on(userActions.verifyEmail, (state) => ({ ...state, user: { ...state.user, emailVerified: true } })),
  // FIXME - Add DELETE_ACCOUNT
);

export const userFeature = createFeature({
  name: 'user',
  reducer: userReducer,
});

export const userStateSelector = createFeatureSelector<any>('user')